import { useEffect, useMemo, useState } from "react";

export interface CountdownValue {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function calculate(targetDate: string): CountdownValue {
  if (!targetDate) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  const target = new Date(targetDate).getTime();
  if (Number.isNaN(target)) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  const diff = Math.max(0, target - Date.now());
  return {
    days: Math.floor(diff / 86_400_000),
    hours: Math.floor((diff / 3_600_000) % 24),
    minutes: Math.floor((diff / 60_000) % 60),
    seconds: Math.floor((diff / 1_000) % 60)
  };
}

export function useCountdown(targetDate: string) {
  const initial = useMemo(() => calculate(targetDate), [targetDate]);
  const [value, setValue] = useState(initial);

  useEffect(() => {
    setValue(calculate(targetDate));
    const timer = window.setInterval(() => setValue(calculate(targetDate)), 1000);
    return () => window.clearInterval(timer);
  }, [targetDate]);

  return value;
}
